export type FeatureFlags = Record<string, boolean>;

// Named registry so consumers reference a constant instead of retyping the Salesforce
// field value as a string literal. Add to this map as each flag gets a real consumer.
export const FEATURE_FLAG_NAMES = {
  intensityScore: "Feature_IntensityScore",
  badges: "Feature_Badges",
  tourGuide: "Feature_TourGuide",
  onboardingTourGuide: "Feature_OnboardingTourGuide",
  featureTourGuide: "Feature_FeatureTourGuide",
} as const;

export type FeatureFlagName = (typeof FEATURE_FLAG_NAMES)[keyof typeof FEATURE_FLAG_NAMES];
